import React from 'react';
import { Stack, Button, Box, Collapse } from '@mui/material';
import EntryItem from './EntryItem';
import { Entry } from '../App';
import { createEntry } from '../utils/createEntry';

interface EntryListProps {
  entries: Entry[];
  setEntries: React.Dispatch<React.SetStateAction<Entry[]>>;
}

const EntryList: React.FC<EntryListProps> = ({
  entries,
  setEntries,
}) => {

  const defaultMarkdown = '# Example Title\r\n\r\nExample paragraph';

  const handleAddEntry = async () => {
    const newEntry = await createEntry('https://label.sentryhive.com', defaultMarkdown);
    newEntry.isEditing = true;
    newEntry.showPreviewWhileEditing = true;
    setEntries(prev => [...prev, newEntry]);
  };


  const isEditingAny = entries.some(entry => entry.isEditing);
  const activeEditingId = entries.find(entry => entry.isEditing)?.id;

  return (
    <Stack spacing={4}>
      {entries.map(entry => (
        <Collapse className="no-margin" key={entry.id} in={true} timeout={400}>
          <EntryItem
            entry={entry}
            setEntries={setEntries}
            isEditingAny={isEditingAny}
            activeEditingId={activeEditingId}
          />
        </Collapse>
      ))}

      {!isEditingAny && (
        <Box className="no-print" textAlign="left">
          <Button
            variant="contained"
            onClick={handleAddEntry}
            aria-label="Add a new entry"
          >
            Add New Entry
          </Button>
        </Box>
      )}
    </Stack>
  );
};

export default EntryList;
